import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Products extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "Products";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,
      description: null,
      type: null,
      id_product: null,
      id_external: null,
      part_number: null,
      sku: null,
      ucc: null,
      upc: null,
      low_stock: 0,
      unit_cost: 0,
      unit_price: 0,
      units_sold: 1, // addon
      unit_of_measure: null,
      is_taxable: true,

      exclude_taxes: false,
      exclude_fees: false,
      exclude_discounts: false,

      meta_key: null, //temp
      meta_value: null, //temp

      image_url: null,
      product_url: null,
      custom_fields: [],
      low_stock_notify: null,
      meta_data: {},
      tags: [],
      notes: [],
      vendor_id: null,

      newKey: null,
      newValue: null,

      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {
    // use this for transforming your data, e.g. transform a Date-string into a Date object; see: https://vuex.feathersjs.com/model-classes.html#setupinstance
    return data;
  }
}
